import axios from 'axios'
import { Message } from 'element-ui'
import { downloadFilesUrl } from '@/utils'
import router from '@/router/index.js'
import errCode from './errorCode'
const messageProxy = {
  error: message => {
    if (document.getElementsByClassName('el-message').length === 0) {
      Message.error(message)
    }
  }
}
axios.defaults.withCredentials = false
axios.defaults.headers['Accept'] = 'application/json'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charest=utf-8'
axios.defaults.headers['responseType'] = 'arraybuffer'
axios.interceptors.request.use(
  config => {
    config.headers = {
      Authorization: `Bearer ${localStorage.getItem('cbaas_system_Token')}`
    }
    return config
  },
  err => {
    messageProxy.error(err.message)
    return Promise.reject(err)
  }
)

// response
axios.interceptors.response.use(
  response => {
    // 文件下载 response
    if (response.headers && response.headers['content-type'] === 'application/octet-stream') {
      downloadFilesUrl(response.request.responseURL)
      response.data = ''
      response.headers['content-type'] = 'application/json'

      return response
    }
    // 登录状态校验
    if (response.data && response.data.status && parseInt(response.data.status) === 401) {
      sessionStorage.clear()
      localStorage.clear()
      return
    }
    if (response && response.errors) {
      messageProxy.error(response.errors[0]['message'])
    }
    return response
  },
  err => {
    if (!err.response) {
      messageProxy.error('网络不通，请检查网络')
    } else if (err.message.indexOf('timeout') !== -1) {
      messageProxy.error('网络请求超时')
    } else {
      messageProxy.error('错误信息：' + errCode[err.response['data']['errors'][0]['code']])
    }
    return Promise.reject(err)
  }
)

const fetch = (method, url, data, singleDeal = false) => {
  const params = method === 'get' ? { params: data } : data

  return axios[method](url, params).then(res => {
    if (singleDeal) {
      return res
    } else {
      if (res.data.code === 0 && res.data.msg) {
        if (res.data.msg === 'token不正确') {
          router.push('/login')
        } else {
          messageProxy.error(res.data.msg)
        }
      } else {
        return res.data
      }
    }
  })
}

export { fetch }
